var _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _g4, _rect5, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 19,
    viewBox: "0 0 90 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.334106,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 13.2904L5.88751 15.1654C5.75001 15.2529 5.60626 15.2904 5.45626 15.2779C5.30626 15.2654 5.17501 15.2154 5.06251 15.1279C4.95001 15.0404 4.86251 14.931 4.80001 14.7998C4.73751 14.6685 4.72501 14.5216 4.76251 14.3591L5.58751 10.8154L2.83126 8.43413C2.70626 8.32163 2.62814 8.19351 2.59689 8.04976C2.56564 7.90601 2.57501 7.76538 2.62501 7.62788C2.67501 7.49038 2.75001 7.37788 2.85001 7.29038C2.95001 7.20288 3.08751 7.14663 3.26251 7.12163L6.90001 6.80288L8.30626 3.46538C8.36876 3.31538 8.46564 3.20288 8.59689 3.12788C8.72814 3.05288 8.86251 3.01538 9.00001 3.01538C9.13751 3.01538 9.27189 3.05288 9.40314 3.12788C9.53439 3.20288 9.63126 3.31538 9.69376 3.46538L11.1 6.80288L14.7375 7.12163C14.9125 7.14663 15.05 7.20288 15.15 7.29038C15.25 7.37788 15.325 7.49038 15.375 7.62788C15.425 7.76538 15.4344 7.90601 15.4031 8.04976C15.3719 8.19351 15.2938 8.32163 15.1688 8.43413L12.4125 10.8154L13.2375 14.3591C13.275 14.5216 13.2625 14.6685 13.2 14.7998C13.1375 14.931 13.05 15.0404 12.9375 15.1279C12.825 15.2154 12.6938 15.2654 12.5438 15.2779C12.3938 15.2904 12.25 15.2529 12.1125 15.1654L9.00001 13.2904Z",
    fill: "#F88D2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_107_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 18,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 0.334106,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_107_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 13.2904L23.8875 15.1654C23.75 15.2529 23.6063 15.2904 23.4563 15.2779C23.3063 15.2654 23.175 15.2154 23.0625 15.1279C22.95 15.0404 22.8625 14.931 22.8 14.7998C22.7375 14.6685 22.725 14.5216 22.7625 14.3591L23.5875 10.8154L20.8313 8.43413C20.7063 8.32163 20.6281 8.19351 20.5969 8.04976C20.5656 7.90601 20.575 7.76538 20.625 7.62788C20.675 7.49038 20.75 7.37788 20.85 7.29038C20.95 7.20288 21.0875 7.14663 21.2625 7.12163L24.9 6.80288L26.3063 3.46538C26.3688 3.31538 26.4656 3.20288 26.5969 3.12788C26.7281 3.05288 26.8625 3.01538 27 3.01538C27.1375 3.01538 27.2719 3.05288 27.4031 3.12788C27.5344 3.20288 27.6313 3.31538 27.6938 3.46538L29.1 6.80288L32.7375 7.12163C32.9125 7.14663 33.05 7.20288 33.15 7.29038C33.25 7.37788 33.325 7.49038 33.375 7.62788C33.425 7.76538 33.4344 7.90601 33.4031 8.04976C33.3719 8.19351 33.2938 8.32163 33.1688 8.43413L30.4125 10.8154L31.2375 14.3591C31.275 14.5216 31.2625 14.6685 31.2 14.7998C31.1375 14.931 31.05 15.0404 30.9375 15.1279C30.825 15.2154 30.6938 15.2654 30.5438 15.2779C30.3938 15.2904 30.25 15.2529 30.1125 15.1654L27 13.2904Z",
    fill: "#F88D2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_107_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 18,
    height: 19
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 0.334106,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_107_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 13.2904L41.8875 15.1654C41.75 15.2529 41.6063 15.2904 41.4563 15.2779C41.3063 15.2654 41.175 15.2154 41.0625 15.1279C40.95 15.0404 40.8625 14.931 40.8 14.7998C40.7375 14.6685 40.725 14.5216 40.7625 14.3591L41.5875 10.8154L38.8313 8.43413C38.7063 8.32163 38.6281 8.19351 38.5969 8.04976C38.5656 7.90601 38.575 7.76538 38.625 7.62788C38.675 7.49038 38.75 7.37788 38.85 7.29038C38.95 7.20288 39.0875 7.14663 39.2625 7.12163L42.9 6.80288L44.3063 3.46538C44.3688 3.31538 44.4656 3.20288 44.5969 3.12788C44.7281 3.05288 44.8625 3.01538 45 3.01538C45.1375 3.01538 45.2719 3.05288 45.4031 3.12788C45.5344 3.20288 45.6313 3.31538 45.6938 3.46538L47.1 6.80288L50.7375 7.12163C50.9125 7.14663 51.05 7.20288 51.15 7.29038C51.25 7.37788 51.325 7.49038 51.375 7.62788C51.425 7.76538 51.4344 7.90601 51.4031 8.04976C51.3719 8.19351 51.2938 8.32163 51.1688 8.43413L48.4125 10.8154L49.2375 14.3591C49.275 14.5216 49.2625 14.6685 49.2 14.7998C49.1375 14.931 49.05 15.0404 48.9375 15.1279C48.825 15.2154 48.6938 15.2654 48.5438 15.2779C48.3938 15.2904 48.25 15.2529 48.1125 15.1654L45 13.2904Z",
    fill: "#F88D2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_107_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 0,
    width: 18,
    height: 19
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 0.334106,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_107_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 13.2904L59.8875 15.1654C59.75 15.2529 59.6063 15.2904 59.4563 15.2779C59.3063 15.2654 59.175 15.2154 59.0625 15.1279C58.95 15.0404 58.8625 14.931 58.8 14.7998C58.7375 14.6685 58.725 14.5216 58.7625 14.3591L59.5875 10.8154L56.8313 8.43413C56.7063 8.32163 56.6281 8.19351 56.5969 8.04976C56.5656 7.90601 56.575 7.76538 56.625 7.62788C56.675 7.49038 56.75 7.37788 56.85 7.29038C56.95 7.20288 57.0875 7.14663 57.2625 7.12163L60.9 6.80288L62.3063 3.46538C62.3688 3.31538 62.4656 3.20288 62.5969 3.12788C62.7281 3.05288 62.8625 3.01538 63 3.01538C63.1375 3.01538 63.2719 3.05288 63.4031 3.12788C63.5344 3.20288 63.6313 3.31538 63.6938 3.46538L65.1 6.80288L68.7375 7.12163C68.9125 7.14663 69.05 7.20288 69.15 7.29038C69.25 7.37788 69.325 7.49038 69.375 7.62788C69.425 7.76538 69.4344 7.90601 69.4031 8.04976C69.3719 8.19351 69.2938 8.32163 69.1688 8.43413L66.4125 10.8154L67.2375 14.3591C67.275 14.5216 67.2625 14.6685 67.2 14.7998C67.1375 14.931 67.05 15.0404 66.9375 15.1279C66.825 15.2154 66.6938 15.2654 66.5438 15.2779C66.3938 15.2904 66.25 15.2529 66.1125 15.1654L63 13.2904Z",
    fill: "#F88D2C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_107_208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 0,
    width: 18,
    height: 19
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 0.334106,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_107_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 13.2904L77.8875 15.1654C77.75 15.2529 77.6063 15.2904 77.4563 15.2779C77.3063 15.2654 77.175 15.2154 77.0625 15.1279C76.95 15.0404 76.8625 14.931 76.8 14.7998C76.7375 14.6685 76.725 14.5216 76.7625 14.3591L77.5875 10.8154L74.8313 8.43413C74.7063 8.32163 74.6281 8.19351 74.5969 8.04976C74.5656 7.90601 74.575 7.76538 74.625 7.62788C74.675 7.49038 74.75 7.37788 74.85 7.29038C74.95 7.20288 75.0875 7.14663 75.2625 7.12163L78.9 6.80288L80.3063 3.46538C80.3688 3.31538 80.4656 3.20288 80.5969 3.12788C80.7281 3.05288 80.8625 3.01538 81 3.01538C81.1375 3.01538 81.2719 3.05288 81.4031 3.12788C81.5344 3.20288 81.6313 3.31538 81.6938 3.46538L83.1 6.80288L86.7375 7.12163C86.9125 7.14663 87.05 7.20288 87.15 7.29038C87.25 7.37788 87.325 7.49038 87.375 7.62788C87.425 7.76538 87.4344 7.90601 87.4031 8.04976C87.3719 8.19351 87.2938 8.32163 87.1688 8.43413L84.4125 10.8154L85.2375 14.3591C85.275 14.5216 85.2625 14.6685 85.2 14.7998C85.1375 14.931 85.05 15.0404 84.9375 15.1279C84.825 15.2154 84.6938 15.2654 84.5438 15.2779C84.3938 15.2904 84.25 15.2529 84.1125 15.1654L81 13.2904Z",
    fill: "#F88D2C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.091d9d207fb33f51cac4a4fcd7332c1f.svg";
export { ForwardRef as ReactComponent };